import React from 'react';

import Navbar from '../../global/Navbar';

import Footer from '../../global/Footer';

import Services from './Services';

import Chatbot from './Chatbot';

import Features from './Features';

import Details from './Details';

import Newsletter from '../../global/Newsletter';

import DeliveryBand from '../../shared/DeliveryBand';

import SectionSurface, { PageFlow } from '../../shared/SectionSurface';

import PageMeta from '../../shared/PageMeta';



function Overview() {

  return (

    <div>

      <PageMeta path="/platform-engineering" />

      <Navbar />

      <PageFlow>

        <SectionSurface

          variant="wash"

          decor="none"

          underNav

          bleed="bottom"

          flowBottom

          overlap

        >

          <Chatbot />

        </SectionSurface>

        <SectionSurface

          variant="dots"

          as="section"

          id="snowflake"

          decor="mesh"

          bleed="both"

          flowTop

          flowBottom

          overlap

          className="scroll-mt-24"

        >

          <Features />

        </SectionSurface>

        <SectionSurface

          variant="subtle"

          decor="contour"

          bleed="both"

          flowTop

          flowBottom

          overlap

        >

          <Services />

        </SectionSurface>

        <DeliveryBand id="delivery" compact variant="muted" decor="dots" />

        <SectionSurface

          variant="flow-blue-soft"

          decor="flow"

          bleed="both"

          flowTop

          overlap

        >

          <Details />

        </SectionSurface>

      </PageFlow>

      <Newsletter />

      <Footer />

    </div>

  );

}



export default Overview;

